export class TicketsServiceLocationsBridge {
    Id?: number;
    TicketId: number;
    LocationId: number;
    IsRepaired: boolean;
}